var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#FF0000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.2314,
    y: 19.3306,
    width: 16.4596,
    height: 13.467,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6763 14C29.7063 14.0349 31.3672 14.0499 33.0331 14.0948C34.1803 14.1247 35.3275 14.1995 36.4797 14.2594C37.0882 14.2893 37.6967 14.3242 38.3052 14.3741C39.3127 14.4539 40.3302 14.5237 41.3128 14.7681C42.8042 15.1422 43.8616 16.0599 44.4751 17.4665C44.7494 18.095 44.8641 18.7683 44.9589 19.4417C45.0586 20.1848 45.1484 20.933 45.2183 21.6812C45.2781 22.3396 45.328 23.0029 45.3479 23.6663C45.3878 24.8983 45.4327 26.1303 45.4178 27.3622C45.4028 28.5992 45.338 29.8362 45.2532 31.0682C45.1784 32.1256 45.0636 33.178 44.924 34.2254C44.8292 34.9686 44.6895 35.7118 44.3354 36.3901C43.6371 37.7119 42.5498 38.5348 41.0784 38.8092C40.4599 38.9289 39.8265 38.9987 39.198 39.0586C38.3152 39.1434 37.4274 39.2082 36.5445 39.2681C35.9659 39.308 35.3874 39.3229 34.8038 39.3429C33.5618 39.3828 32.3149 39.4326 31.0729 39.4526C29.5616 39.4775 28.0503 39.4975 26.539 39.4875C24.943 39.4825 23.3519 39.4476 21.7558 39.4127C20.7183 39.3927 19.6809 39.3728 18.6484 39.303C17.0473 39.1932 15.4462 39.1234 13.8551 38.884C12.6082 38.6945 11.5209 38.2106 10.6879 37.2231C10.1043 36.5298 9.76019 35.7217 9.62552 34.8339C9.4709 33.8114 9.33623 32.7839 9.23148 31.7565C9.022 29.6367 8.96214 27.5119 9.022 25.3871C9.0619 24.0105 9.16166 22.6338 9.27139 21.2572C9.35618 20.1799 9.46092 19.0975 9.77016 18.0551C10.3039 16.2245 11.5159 15.0724 13.3913 14.6933C14.2492 14.5237 15.127 14.4389 15.9949 14.3691C17.4064 14.2594 18.818 14.1845 20.2345 14.1247C21.4266 14.0748 22.6137 14.0599 23.8058 14.0399C25.2173 14.0299 26.6288 14.015 27.6763 14ZM23.6013 21.2921C23.6013 24.9482 23.6013 28.5743 23.6013 32.2253C26.7635 30.4048 29.9058 28.5942 33.088 26.7637C29.9058 24.9332 26.7735 23.1226 23.6013 21.2921Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.b9d06a39a4f9d1059c1363a5a4fef337.svg";
export { ForwardRef as ReactComponent };